export default __webpack_public_path__ + "assets/images/v-icon3-11eacd6a.svg";